"use client";

import { memo } from "react";
import type { StockListingUILabels } from "../../../interfaces/StockListingTableAEM.interface";
import { useStockListingFilters } from "../context/StockListingFiltersContext";
import StockActiveFilterChips from "./StockActiveFilterChips";

export interface StockHeaderBarMobileDynamicContentProps {
  uiLabels?: StockListingUILabels;
  initialHasActiveFilters?: boolean;
}

const StockHeaderBarMobileDynamicContent = memo(
  ({ uiLabels = {}, initialHasActiveFilters = false }: StockHeaderBarMobileDynamicContentProps) => {
    const { activeFilters } = useStockListingFilters();
    const hasActiveFilters =
      (activeFilters?.index?.length ?? 0) > 0 ||
      (activeFilters?.sector?.length ?? 0) > 0 ||
      (activeFilters?.mktcap?.length ?? 0) > 0 ||
      (activeFilters?.alphabetic?.length ?? 0) > 0;

    if (!hasActiveFilters) {
      return null;
    }

    return (
      <div
        className={
          initialHasActiveFilters
            ? "p-4 md:px-0 w-79 md:w-unset"
            : "absolute inset-0 bg-white p-4 md:px-0"
        }
      >
        <StockActiveFilterChips uiLabels={uiLabels} mode="mobileHeader" />
      </div>
    );
  },
);

StockHeaderBarMobileDynamicContent.displayName = "StockHeaderBarMobileDynamicContent";

export default StockHeaderBarMobileDynamicContent;